import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import { SignupLink, EventDate, EventDetails, EmailSignupText } from '../constants';

const Callout = () => {
    return (
        <section>
            <Row className="flex-column p-3 px-5 p-sm-5">
                {/* <Row>
                    <Col className="border-special text-sm-right h1 text-uppercase bolder pb-3 pb-sm-0 text-center text-sm-left" xs="12" md="5">
                        {EventDate}
                    </Col>
                    <Col style={{ fontWeight: 600 }} xs="12" md="7" lg="5">
                        {EventDetails}
                    </Col>
                </Row> */}
                <Row className="pb-0">
                    <Col>
                        <h1 className="text-center">Thank you for joining us!</h1>
                    </Col>
                </Row>
                <Button className="mt-5 mb-3 mx-auto rounded-pill"
                    href={SignupLink}
                    target="_blank">
                    {EmailSignupText}
                </Button>
                <p className="text-center">Sign up for exclusive event news and surprises!</p>
            </Row>
        </section>
    );
}

export default Callout;